import Vue from 'vue';

import '@/assets/fonts/gilroy/stylesheet.css';

import '@/assets/scss/style.scss';

import { default_language as locale } from '@/config';

Vue.config.productionTip = process.env.NODE_ENV !== 'development';

import 'iframe-resizer/js/iframeResizer.contentWindow.js';

Vue.use(require('vue-form-generator').install);

import http from '@/config/http';
Vue.use(http);

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import VueMeta from 'vue-meta';
Vue.use(VueMeta, { refreshOnceOnNavigation: true });

import { VBModal } from 'bootstrap-vue';
Vue.directive('b-modal', VBModal);

import { ModalPlugin, TooltipPlugin } from 'bootstrap-vue';

Vue.use(ModalPlugin);

Vue.use(TooltipPlugin);

//import fieldLabel from '@/components/form/fieldLabel.vue';
//Vue.component('fieldLabel', fieldLabel);

const i18n = new VueI18n({
   locale,
   messages: {
      en: require('@/i18n/en.json'),
      lv: require('@/i18n/lv.json'),
      ru: require('@/i18n/ru.json'),
   },
});

import { buildDropDown, unixDateToTime } from '@/config/functions';
Vue.filter('buildDropDown', buildDropDown);
Vue.filter('unixDateToTime', unixDateToTime);

// @ts-ignore
import Loading from 'vue-loading-overlay';
Vue.use(Loading, {
   color: '#4662D4',
   container: null,
   canCancel: false,
   width: 64,
   height: 64,
});

import App from '@/App.vue';

new Vue({
   i18n,
   render: h => h(App),
}).$mount('#app');
